import { ApiType } from "@gymflow/common";
import { PublicMembershipApiType } from "@gymflow/common/lib/api/publicMembershipApi";
import { useQuery } from "@tanstack/react-query";

import { membershipAsPublicQueryKeys } from "./membershipAsPublicQueryKeys";

export function useQueryMembershipAsPublic({
  api,
  membershipId,
}: {
  api: ApiType;
  membershipId?: Parameters<PublicMembershipApiType["getById"]>[0];
}) {
  return useQuery({
    queryKey: membershipAsPublicQueryKeys.details(membershipId),
    queryFn: async () => {
      return (await api.public.membershipApi.getById(membershipId!)).data;
    },
    enabled: !!membershipId,
  });
}
